import React from 'react';
import ReactDOM from 'react-dom';
import './ProcessingDialog.css';

/**
 * ProcessingDialog - A reusable floating dialog that shows the lantern logo
 * with pulsing glow animation and dynamic status text.
 * Rendered as a portal to document.body so it floats above all content.
 *
 * @param {boolean} show - Whether to display the dialog
 * @param {string} text - Status text to display beneath the lantern
 */
function ProcessingDialog({ show, text }) {
  if (!show) return null;

  return ReactDOM.createPortal(
    <div className="processing-dialog-overlay">
      <div className="processing-dialog">
        <div className="processing-dialog-lantern">
          <img
            src="/images/btm-circle-logo.png"
            alt="Processing"
            className="processing-dialog-lantern-icon"
          />
        </div>
        {text && <span className="processing-dialog-text">{text}</span>}
      </div>
    </div>,
    document.body
  );
}

export default ProcessingDialog;
